import React, { useState } from "react";

export default function Notifications() {
  const [notifications, setNotifications] = useState({
    assignment: {
      enabled: true,
      subject: "Course Assigned",
      body: "Hello {{user}},\n\nYou’ve been assigned {{course}}.",
    },
    reminder: {
      enabled: true,
      subject: "Course Reminder",
      body: "Hi {{user}},\n\nThis is a reminder to complete {{course}} by {{due_date}}.",
    },
    overdue: {
      enabled: true,
      subject: "Course Overdue",
      body: "Hi {{user}},\n\nThe following course is now overdue: {{course}}.",
    },
    completion: {
      enabled: true,
      subject: "Course Completed",
      body: "Hi {{user}},\n\nYou’ve successfully completed {{course}}. Well done!",
    },
  });

  const [preview, setPreview] = useState({ open: false, subject: "", body: "" });

  const handleChange = (type, field, value) => {
    setNotifications((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [field]: field === "enabled" ? value : value.trim(),
      },
    }));
  };

  const saveChanges = () => {
    alert("Notification settings saved.");
  };

  const openPreview = (subject, body) => {
    const course = "Safety Training";
    const due_date = "10/06/2025";
    const user = "Adem Mete";

    const replacePlaceholders = (text) =>
      text
        .replace(/{{course}}/g, course)
        .replace(/{{due_date}}/g, due_date)
        .replace(/{{user}}/g, user);

    setPreview({
      open: true,
      subject: replacePlaceholders(subject),
      body: replacePlaceholders(body),
    });
  };

  const closePreview = () => {
    setPreview({ open: false, subject: "", body: "" });
  };

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-10">
      <h2 className="text-2xl font-bold mb-4">Notification Settings</h2>

      {Object.entries(notifications).map(([key, config]) => (
        <div key={key} className="bg-white p-6 rounded shadow space-y-4 border">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold capitalize">{key} Notification</h3>
            <label className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={config.enabled}
                onChange={(e) => handleChange(key, "enabled", e.target.checked)}
              />
              <span>Email Enabled</span>
            </label>
          </div>

          <input
            type="text"
            className="w-full border rounded px-3 py-2"
            value={config.subject}
            onChange={(e) => handleChange(key, "subject", e.target.value)}
            placeholder="Email Subject"
          />

          <textarea
            className="w-full border rounded px-3 py-2"
            rows={4}
            value={config.body}
            onChange={(e) => handleChange(key, "body", e.target.value)}
            placeholder="Email Body"
          />

          <div className="flex justify-between items-center">
            <p className="text-sm text-gray-500">
              Variables: <code>{{user}}</code>, <code>{{course}}</code>, <code>{{due_date}}</code>
            </p>
            <button
              className="text-blue-600 hover:underline text-sm"
              onClick={() => openPreview(config.subject, config.body)}
            >
              Preview
            </button>
          </div>
        </div>
      ))}

      <button
        className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700"
        onClick={saveChanges}
      >
        Save Changes
      </button>

      {/* Preview Modal */}
      {preview.open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded shadow-lg w-full max-w-md space-y-4">
            <h4 className="text-xl font-semibold">Preview Email</h4>
            <p><strong>Subject:</strong> {preview.subject}</p>
            <p><strong>Body:</strong></p>
            <div className="border p-3 rounded bg-gray-50 whitespace-pre-line">{preview.body}</div>
            <div className="text-right">
              <button
                onClick={closePreview}
                className="mt-4 px-4 py-2 bg-black text-white rounded hover:bg-gray-800"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
